// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"9eadec96","208":"920ce939","236":"d89da081","353":"235c53bf","512":"cddf1d0b","549":"0fb1d99b","813":"a451f931"}[chunkId] + ".chunk.js";
};